<template>
	<PopUp
		v-if="show"
		title="Unsere Webseite verwendet Cookies"
		size="lg"
		hide-actions
		:closable="closable"
	>
		<div class="consent-popup">
			<div class="intro">
				Weitere Informationen zu Cookies erhalten Sie in diesem Cookiebanner und in unserer Datenschutzerklärung
				(siehe unten). Klicken Sie auf "Alle Cookies erlauben", um alle Arten von Cookies zu akzeptieren oder
				klicken Sie auf "Nur erforderliche Cookies erlauben" um nur jene Cookies zu zulassen, die für den
				Betrieb und Funktion der Webseite unbedingt erforderlich sind.
			</div>
			<form class="categories">
				<div
					v-for="category in categories"
					:key="category.key"
				>
					<b-form-checkbox
						:id="'consent-category-' + category.key"
						:disabled="category.disabled"
						:checked="isChecked(category)"
						@change="categoryChanged(category)"
					>
						{{ category.title }}
					</b-form-checkbox>
				</div>
			</form>
			<div class="button-container">
				<Button
					text="Alle erlauben"
					bluegray
					uppercase
					@click="save(true)"
				/>
				<Button
					text="Einstellungen übernehmen"
					uppercase
					@click="save(false)"
				/>
			</div>
			<div class="details">
				<a href="#" @click.prevent="showDetails = !showDetails">
					{{ showDetailsLinkText }}
					<Icon v-if="!showDetails" icon="arrow-right"/>
				</a>
				<template v-if="showDetails">
					<div
						v-for="category in categories"
						:key="category.key"
						class="category"
					>
						<a href="#" class="title" @click.prevent="toggleCookies(category)">
							{{ category.title }} ({{ category.cookies.length }})
							<Icon v-if="!isShowCookies(category)" icon="arrow-right"/>
						</a>
						<div class="description">{{ category.description }}</div>
						<div v-if="isShowCookies(category)" class="cookies">
							<div
								v-for="cookie in category.cookies"
								:key="cookie.name"
								class="cookie"
							>
								<div class="name">{{ cookie.name }}</div>
								<div class="description">{{ cookie.description }}</div>
								<div class="duration"><span>Speicherdauer:</span> {{ cookie.duration }}</div>
							</div>
						</div>
					</div>
					<div class="category">
						<div class="title">Über Cookies</div>
						<div class="description">
							<p>Cookies sind kleine Datenpakete, die zwischen Ihrem Browser und unserem Webserver
								ausgetauscht werden. Cookies können nur Informationen speichern, die von Ihrem Browser
								geliefert werden.</p>
							<p>Je nach Verwendungszweck sind Cookies technisch erforderlich oder werden für Statistik-
								oder Marketingzwecke genutzt. Die Verwendung von technisch erforderlichen Cookies beruht
								auf unserem berechtigten Interesse am technisch einwandfreien Betrieb und an der
								reibungslosen Funktionalität unserer Website. Die Verwendung von Statistik- und
								Marketing-Cookies benötigt eine Einwilligung. Diese ist freiwillig und kann jederzeit
								für die Zukunft durch den Aufruf der Cookie Einstellungen widerrufen werden.</p>
							<p>Sie können Ihren Browser auch so einstellen, dass das Speichern von Cookies generell
								verhindert wird. Einmal gesetzte Cookies können Sie jederzeit wieder löschen. Wie all
								dies im Einzelnen funktioniert, finden Sie in der Hilfe-Funktion Ihres Browsers. Bitte
								beachten Sie, dass eine generelle Deaktivierung von Cookies gegebenenfalls zu
								Funktionseinschränkungen auf unserer Website führen kann.</p>
							<p>Nähere Informationen, welche Daten in Cookies gespeichert, zu welchen Zwecken diese
								verwendet und für wie lange Daten gespeichert werden, erhalten Sie in unserer
								Datenschutzerklärung und in unserem Cookie Banner.</p>
						</div>
					</div>
				</template>
			</div>
		</div>
	</PopUp>
</template>
<script>
import PopUp from "@/vue/common/PopUp";
import _ from "lodash";
import Button from "@/vue/common/Button";
import * as Consent from "@/helper/layout/Consent";
import {isDefined} from "@/helper/Value";
import Icon from "@/vue/icon/Icon";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";
import EventBus from "@/event/EventBus";
import {SHOW_CONSENT} from "@/event/Event";

const CATEGORIES = [
	{
		key: Consent.REQUIRED,
		title: 'Erforderlich',
		disabled: true,
		description: 'Technisch notwendige Cookies dienen dazu, um den technischen Betrieb einer Webseite zu ermöglichen und diese für Sie funktional nutzbar zu machen. Die Nutzung erfolgt aufgrund unseres berechtigten Interesses eine technisch einwandfreie Webseite anzubieten. Sie können jedoch generell die Cookie Nutzung in Ihrem Browser deaktivieren.',
		cookies: [
			{
				name: 'PHPSESSID',
				description: 'Erforderlich für die Wiedererkennung des Benutzers.',
				duration: 'Sitzung',
			},
			{
				name: 'consent',
				description: 'Wir speichern deine Auswahl der Cookie-Einstellungen.',
				duration: '1 Jahr',
			},
			// {
			// 	name: '_pk_id*',
			// 	description: 'Speichert ein paar Details zu statistischen Zwecken.',
			// 	duration: '13 Monate',
			// },
			// {
			// 	name: '_pk_ref*',
			// 	description: 'Speichert den Referrer des initialen Websiteaufrufs.',
			// 	duration: '6 Monate',
			// },
			// {
			// 	name: '_pk_ses',
			// 	description: 'Speichert temporäre Daten für den Websitebesuch.',
			// 	duration: '30 Minuten',
			// },
			// {
			// 	name: '_pk_cvar',
			// 	description: 'Speichert temporäre Daten für den Websitebesuch.',
			// 	duration: '30 Minuten',
			// },
			// {
			// 	name: '_pk_hsr',
			// 	description: 'Speichert temporäre Daten für den Websitebesuch.',
			// 	duration: '30 Minuten',
			// },
		],
	},
	// {
	// 	key: Consent.STATISTIC,
	// 	title: 'Statistik',
	// 	description: 'Statistik-Cookies sammeln Informationen darüber, wie Webseiten genutzt werden, um folglich deren Attraktivität, Inhalt und Funktionalität zu verbessern. Eine Nutzung erfolgt nur mit Ihrer Einwilligung und zwar nur solange Sie das jeweilige Cookie nicht deaktiviert haben.',
	// 	cookies: [
	//
	// 	],
	// }
];

export default {
	components: {
		Icon,
		Button,
		PopUp
	},

	data ()
	{
		const data = Consent.getData();

		return {
			show: !isDefined(data),
			categories: CATEGORIES,
			checkedCategories: data?.checkedCategories || [],
			showDetails: false,
			showCookies: [],
			closable: false,
		};
	},

	mounted ()
	{
		EventBus.$on(SHOW_CONSENT, () =>
		{
			this.show = true;
		});
	},

	computed: {
		showDetailsLinkText ()
		{
			return this.showDetails ? 'Details ausblenden' : 'Details anzeigen';
		},
	},

	methods: {
		toggleCookies (category)
		{
			this.showCookies = _.xor(this.showCookies, [category.key]);
		},
		isShowCookies (category)
		{
			return _.includes(this.showCookies, category.key);
		},
		categoryChanged (category)
		{
			this.checkedCategories = _.xor(this.checkedCategories, [category.key]);
		},
		isChecked (category)
		{
			if (category.disabled)
			{
				return true;
			}

			return _.includes(this.checkedCategories, category.key);
		},
		save (all)
		{
			let checkedCategories = this.checkedCategories;

			if (all)
			{
				checkedCategories = _
					.chain(this.categories)
					.filter(c => !c.disabled)
					.map(c => c.key)
					.value();
			}

			let action = 'Alle erlauben';

			if (!all)
			{
				action = 'Einstellungen übernehmen';

				if (checkedCategories.length > 0)
				{
					action += ' (' + checkedCategories.join(', ') + ')';
				}
			}

			Event.push(
				new EventData()
					.setEvent(Event.CONSENT)
					.setAction(action)
			);

			Consent.setData({
				checkedCategories
			});

			location.reload();
		}
	},
}
</script>
